import { render, staticRenderFns } from "./arvioitava-kokonaisuus.vue?vue&type=template&id=58905504&scoped=true&"
import script from "./arvioitava-kokonaisuus.vue?vue&type=script&lang=ts&"
export * from "./arvioitava-kokonaisuus.vue?vue&type=script&lang=ts&"
import style0 from "./arvioitava-kokonaisuus.vue?vue&type=style&index=0&id=58905504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58905504",
  null
  
)

export default component.exports